import { userService } from '@/services/userService'
import { observer } from 'mobx-react'
import styles from './UserWatermark.module.less'

const WATERMARK_COUNT = 60

interface UserWatermarkProps {
    visible?: boolean
}

const UserWatermark = observer(({
    visible = true,
}: UserWatermarkProps): JSX.Element | null => {
    const userId = userService.userData?.inviteCode

    if (!visible || !userId) {
        return null
    }

    return (
        <div className={styles.watermark} aria-hidden='true'>
            {Array.from(
                { length: WATERMARK_COUNT },
                (_: undefined, index: number): JSX.Element => (
                    <span className={styles.watermarkText} key={index}>
                        id:{userId}
                    </span>
                )
            )}
        </div>
    )
})

export default UserWatermark
